/* eslint-disable no-return-assign */
import PaymentController from '@/assets/controllers/PaymentController'
import CartController from '@/assets/controllers/CartController'
// import Util from '@/assets/libs/util'
import eventModule from '@/assets/libs/eventModule'

const salvaDadoTemporario = function (params, retornoContinua) {
    // Para manter a lógica do TAA antigo, o array montado seria esse:
    // printData.push(retornoContinua.bufferConverted)

    // A rotina do TAA antigo parece estar bem errada. Ela salvava os dados em um TXT, mas o campo da resposta que ele
    // salvava é um campo que nunca tem dados. O campo onde os dados são realmente recebidos ele ignorava
    // printData.push(retornoContinua.tamBuffer)
    // console.log(printData)
}

const defaultBufferConvertedReturn = function (retornoContinua, val = '') {
    retornoContinua['bufferConverted'] = val
    return false
}

const encodeUtf8 = function (code) {
    return unescape(encodeURIComponent(code))
}

const carregaDadosTransacao = function (CDFILIAL, CDCAIXA) {
    // n sei
}

const trataTipoRece = function (CDTIPORECE, CDBANCARTCR, IDTIPORECE) {
    // n sei
}

// const extractPaymentNumber = function (bufferString) {
//     // Essa lógica funciona especificamente para a Carteira Digital
//     let index = bufferString.indexOf('DOCUMENTO = ')
//     let paymentNumber = bufferString.substring(index + 12, index + 24)
//     PaymentController.setPaymentNumber(paymentNumber)

//     // Essa lógica funciona para cartão de débito (crédito precisa testar)
//     // let index = bufferString.indexOf('AUT=')
//     // let paymentNumber = bufferString.substring(index + 4, index + 10)
//     // PaymentController.setPaymentNumber(paymentNumber)

//     // Salva o paymentNumber no Local Storage. O valor ficará armazenado até que os dados do pedido sejam recebidos
//     // pela Odhen Interface, para possibilitar o estorno do pagamento se necessário
//     Util.setLocalVar('ultimoNumeroTEF', paymentNumber)
// }

const retornoConfiguracaoTrad = function (retornoContinua) {
    const retorno = {
        0: {
            'error': false,
            'message': 'Não ocorreu erro'
        },
        1: {
            'error': true,
            'message': 'Endereço IP inválido ou não resolvido.'
        },
        2: {
            'error': true,
            'message': 'Código da loja inválido.'
        },
        3: {
            'error': true,
            'message': 'Código de terminal invalido.'
        },
        6: {
            'error': true,
            'message': 'Erro na inicialização do Tcp/Ip.'
        },
        7: {
            'error': true,
            'message': 'Falta de memória.'
        },
        8: {
            'error': true,
            'message': 'Não encontrou a CliSiTef ou ela está com problemas.'
        },
        10: {
            'error': true,
            'message': 'Erro de acesso na pasta CliSiTef (Possível falta de permissão para escrita).'
        }
    }

    return retorno[retornoContinua] ? retorno[retornoContinua] : {
        'error': true,
        'message': 'Falha ao configurar o Cliente SiTef.'
    }
}

const retornoContinuaTrad = function (retornoContinua, CDFILIAL = null, CDCAIXA = null, datecancel, docnumber, valorTotal) {
    const retorno = {
        0: function (retornoContinua, CDFILIAL = null, CDCAIXA = null, datecancel, docnumber, valorTotal) {
            const case0 = {
                0: function (retornoContinua) {
                    return defaultBufferConvertedReturn(retornoContinua)
                },
                545: function (retornoContinua) {
                    return {
                        'error': false,
                        'tipoCampo': retornoContinua['tipoCampo'],
                        'comando': retornoContinua['comando'],
                        'finishedTransaction': false,
                        'message': retornoContinua['bufferConverted']
                    }
                },
                106: function (retornoContinua) {
                    // aqui vai vir o codigo da carteira digital
                    return defaultBufferConvertedReturn(retornoContinua, '80011001')
                },
                107: function (retornoContinua) {
                    // aqui vem o nome da carteira digital selecionada
                    let digitalWalletName = retornoContinua.bufferConverted
                    CartController.setDigitalWalletName(digitalWalletName)
                },
                15: function (retornoContinua) {
                    return defaultBufferConvertedReturn(retornoContinua)
                },
                43: function (retornoContinua) {
                    return defaultBufferConvertedReturn(retornoContinua)
                },
                121: function (retornoContinua) {
                    // Extrai o numero do comprovante a partir da string retornada pelo SiTef e o armazena, para depois
                    // ser passado para a Odhen Interface no momento de salvar a comanda paga
                    // Esse paymentNumber que saía daqui não era o NSU correto, mas ainda pode ser necessário (NFCE).
                    // Se não for usado, apagar todo essse código daqui junto com a função extractPaymentNumber
                    // extractPaymentNumber(retornoContinua.tamBuffer)
                    PaymentController.setCancelTefProof(retornoContinua.bufferConverted)
                    PaymentController.setComprovanteTef(retornoContinua.bufferConverted)
                    return defaultBufferConvertedReturn(retornoContinua)
                },
                122: function (retornoContinua) {
                    // Aqui eu consigo a segunda via do comprovante, mais completa, caso necessario.
                    // O 121, acima, contem a primeira via (do consumidor) que é mais enxuta
                    return defaultBufferConvertedReturn(retornoContinua)
                },
                123: function (retornoContinua) {
                    return defaultBufferConvertedReturn(retornoContinua)
                },
                132: function (retornoContinua) {
                    // De acordo com a documentação do SiTef, aqui vem o código da bandeira do cartao
                    let bandeiraCartao = retornoContinua.bufferConverted
                    CartController.setbandeiraCartao(bandeiraCartao)

                    return defaultBufferConvertedReturn(retornoContinua)
                },
                133: function (retornoContinua) {
                    salvaDadoTemporario(CDFILIAL + CDCAIXA + 'comprovanteTef', retornoContinua)
                    return defaultBufferConvertedReturn(retornoContinua)
                },
                134: function (retornoContinua) {
                    // Recupera o NSU (Número Sequencial Único) do Host autorizador
                    let paymentNumber = retornoContinua.bufferConverted
                    PaymentController.setPaymentNumber(paymentNumber)

                    return defaultBufferConvertedReturn(retornoContinua)
                },
                135: function (retornoContinua) {
                    let authHash = retornoContinua.bufferConverted
                    PaymentController.setHashCode(authHash)
                },
                504: function (retornoContinua) {
                    return defaultBufferConvertedReturn(retornoContinua, '0')
                },
                1: function (retornoContinua) {

                },
                2: function (retornoContinua) {

                },
                7: function (retornoContinua) {
                    return defaultBufferConvertedReturn(retornoContinua, '80011001')
                },
                23: function (retornoContinua) {
                    PaymentController.setCommandSitef(23)
                },
                951: function (retornoContinua) {

                },
                952: function (retornoContinua) {

                },
                953: function (retornoContinua) {
                    return defaultBufferConvertedReturn(retornoContinua)
                },
                2620: function (retornoContinua) {
                    let authHash = retornoContinua.bufferConverted
                    PaymentController.setHashCode(authHash)
                }
            }
            // chamada para o retornoContinua['comando'] === 0
            return !case0[retornoContinua.tipoCampo] ? {} : case0[retornoContinua.tipoCampo](retornoContinua)
        },
        1: function (retornoContinua) {
            return defaultBufferConvertedReturn(retornoContinua)
        },
        2: function (retornoContinua) {
            return defaultBufferConvertedReturn(retornoContinua)
        },
        3: function (retornoContinua) {
            return {
                'error': false,
                'tipoCampo': retornoContinua['tipoCampo'],
                'comando': retornoContinua['comando'],
                'finishedTransaction': false,
                'message': retornoContinua['bufferConverted']
            }
        },
        4: function (retornoContinua) {
            return defaultBufferConvertedReturn(retornoContinua, '')
        },
        14: function (retornoContinua) {
            return defaultBufferConvertedReturn(retornoContinua, '')
        },
        13: function (retornoContinua) {
            return defaultBufferConvertedReturn(retornoContinua, '')
        },
        15: function (retornoContinua) {
            return defaultBufferConvertedReturn(retornoContinua, '')
        },
        20: function (retornoContinua) {
            return defaultBufferConvertedReturn(retornoContinua, '1')
        },
        21: function (retornoContinua) {
            let eventData = {
                options: retornoContinua.bufferConverted
            }
            eventModule.$emit('optionsReceived', eventData)
            return defaultBufferConvertedReturn(retornoContinua, '1')
        },
        22: function (retornoContinua) {
            return {
                'error': true,
                'message': retornoContinua['bufferConverted'].toString().trim()
            }
        },
        23: function (retornoContinua) {
            return defaultBufferConvertedReturn(retornoContinua, '')
        },
        30: function (retornoContinua) {
            const case30 = {
                500: function (retornoContinua) {
                    // Passa um valor qualquer para evitar entrar em loop infinito
                    let securityCode = 0
                    let result = {
                        sendBuffer: true,
                        bufferMessage: securityCode
                    }
                    return result
                },
                514: function (retornoContinua) {
                    // Passa um valor qualquer para evitar entrar em loop infinito
                    /* let securityCode = 0
                    let result = {
                        sendBuffer: true,
                        bufferMessage: securityCode
                    }
                    return result */
                    return defaultBufferConvertedReturn(retornoContinua)
                },
                515: function (retornoContinua) {
                    /* let cancelData = PaymentController.getCancelTefData()
                    let date = cancelData.date
                    let result = {
                        sendBuffer: true,
                        bufferMessage: date
                    }
                    return result */
                    return defaultBufferConvertedReturn(retornoContinua)
                },
                516: function (retornoContinua) {
                    // let expectedNsuLength = parseInt(retornoContinua.tamMaximo)
                    /* let expectedNsuLength = parseInt(Util.getLocalConfigs('comprimentoNSU') || 0)
                    let cancelData = PaymentController.getCancelTefData()
                    let nsu = cancelData.nsu

                    if (process.env.NODE_ENV === 'production' && nsu.length < expectedNsuLength) {
                        let numberOfZeros = expectedNsuLength - nsu.length
                        for (let i = 0; i < numberOfZeros; i++) {
                            nsu = '0' + nsu
                        }
                    }

                    let result = {
                        sendBuffer: true,
                        bufferMessage: nsu,
                        tamBuffer: nsu.length
                    }
                    return result */
                    return defaultBufferConvertedReturn(retornoContinua)
                }
            }
            // chamada para o retornoContinua['comando'] === 30
            return !case30[retornoContinua.tipoCampo] ? {} : case30[retornoContinua.tipoCampo](retornoContinua)
        },
        34: function (retornoContinua) {
            const case34 = {
                146: function (retornoContinua) {
                    let cancelData = PaymentController.getCancelTefData()
                    let value = cancelData.value
                    let result = {
                        sendBuffer: true,
                        bufferMessage: value
                    }
                    return result
                },
                147: function (retornoContinua) {
                    let cancelData = PaymentController.getCancelTefData()
                    let value = cancelData.value
                    let result = {
                        sendBuffer: true,
                        bufferMessage: value
                    }
                    return result
                }
            }
            // chamada para o retornoContinua['comando'] === 30
            return !case34[retornoContinua.tipoCampo] ? {} : case34[retornoContinua.tipoCampo](retornoContinua)
        },
        50: function (retornoContinua) {
            const case50 = {
                584: function (retornoContinua) {
                    let qrCode = retornoContinua.bufferConverted
                    let eventData = {
                        qrCode: qrCode
                    }
                    eventModule.$emit('qrCodeReceived', eventData)
                    defaultBufferConvertedReturn(retornoContinua, '')
                    return {
                        'error': false,
                        'tipoCampo': retornoContinua['tipoCampo'],
                        'comando': retornoContinua['comando'],
                        'finishedTransaction': false,
                        'message': qrCode
                    }
                }
            }
            // chamada para o retornoContinua['comando'] === 30
            return !case50[retornoContinua.tipoCampo] ? {} : case50[retornoContinua.tipoCampo](retornoContinua)
        },
        51: function (retornoContinua) {
            eventModule.$emit('removeQrCode')
            return defaultBufferConvertedReturn(retornoContinua)
        },
        52: function (retornoContinua) {
            let eventData = {
                message: retornoContinua.bufferConverted
            }
            eventModule.$emit('footerMessageReceived', eventData)
            return defaultBufferConvertedReturn(retornoContinua)
        }
    }

    return !retorno[retornoContinua.comando] ? {
        'error': true,
        'message': 'Falha ao configurar o Cliente SiTef.'
    } : retorno[retornoContinua.comando](retornoContinua, CDFILIAL = null, CDCAIXA = null, datecancel, docnumber, valorTotal)
}

const retornoDll = function (retornoContinua) {
    const retorno = {
        '-1': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Módulo não inicializado. O PDV tentou chamar alguma rotina sem antes executar a função configura.',
                'finishedTransaction': true
            }
        },
        '-2': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Operação cancelada pelo operador.',
                'finishedTransaction': true
            }
        },
        '-3': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'O parâmetro função / modalidade é inválido.',
                'finishedTransaction': true
            }
        },
        '-4': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Falta de memória no PDV.',
                'finishedTransaction': true
            }
        },
        '-5': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Sem comunicação com o SiTef.',
                'finishedTransaction': true
            }
        },
        '-6': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Operação cancelada pelo usuário (no pinpad).',
                'finishedTransaction': true
            }
        },
        '-7': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Reservado',
                'finishedTransaction': true
            }
        },
        '-8': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'A CliSiTef não possui a implementação da função necessária, provavelmente está desatualizada (a CliSiTefI é mais recente).',
                'finishedTransaction': true
            }
        },
        '-9': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'A automação chamou a rotina ContinuaFuncaoSiTefInterativo sem antes iniciar uma função iterativa.',
                'finishedTransaction': true
            }
        },
        '-10': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Algum parâmetro obrigatório não foi passado pela automação comercial.',
                'finishedTransaction': true
            }
        },
        '-12': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Erro na execução da rotina iterativa. Provavelmente o processo iterativo anterior não foi finalizado (enquanto o retorno for igual a 10000).',
                'finishedTransaction': true
            }
        },
        '-15': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Operação cancelada pela automação comercial.',
                'finishedTransaction': true
            }
        },
        '-20': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Parâmetro inválido passado para a função.',
                'finishedTransaction': true
            }
        },
        '-21': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Utilizada uma palavra proibida, por exemplo SENHA, para coletar dados em aberto no pinpad. Por exemplo na função ObtemDadoPinpadDiretoEx.',
                'finishedTransaction': true
            }
        },
        '-25': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Erro no Correspondente bancário: Deve realizar sangria.',
                'finishedTransaction': true
            }
        },
        '-30': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Erro de acesso ao arquivo. Certifique-se que o usuário que roda a aplicação tem direitos de leitura/escrita.',
                'finishedTransaction': true
            }
        },
        '-40': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Transação negada pelo SiTef.',
                'finishedTransaction': true
            }
        },
        '-41': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Dados inválidos.',
                'finishedTransaction': true
            }
        },
        '-42': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Reservado',
                'finishedTransaction': true
            }
        },
        '-43': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Problema na execução de alguma das rotinas no pinpad.',
                'finishedTransaction': true
            }
        },
        '-50': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Transação não segura.',
                'finishedTransaction': true
            }
        },
        '-100': function () {
            return {
                'error': true,
                'canceled': true,
                'message': 'Erro interno do módulo.',
                'finishedTransaction': true
            }
        }
    }
    return retorno[retornoContinua.retornoDll] ? retorno[retornoContinua.retornoDll]() : {
        'error': true,
        'canceled': true,
        'message': 'Erro desconhecido. Erro: ' + retornoContinua['retornoDll'] + '.',
        'finishedTransaction': true
    }
}

export default {
    trataTipoRece,
    carregaDadosTransacao,
    encodeUtf8,
    retornoConfiguracaoTrad,
    retornoContinuaTrad,
    retornoDll
}



// WEBPACK FOOTER //
// ./src/assets/tef/ContinuaTransacaoTefOBJ.js